module.exports = __webpack_public_path__ + "static/media/cow.6df5e5ba.svg";